import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const PayModalUI = ({ context, successMsg, errorList, setErrorList, selectedBill, payMode, onPayCancel,
	// modes
	submitted, otpRequested,
	// event handlers
	onSubmit,
	// form fields
	billName, billAmount, otp, onOtpChange, otpError, setOtpError
}) =>
	<ModalFormUI
		context={context}
		titleLabel='Pay Use of Proceeds'
		buttonLabel={otpRequested ? 'Confirm' : 'GET OTP'}
		cancelLabel='Cancel'
		isOpen={payMode}
		onRequestClose={onPayCancel}
		successMsg={successMsg}
		errorList={errorList}
		setErrorList={setErrorList}
		onSubmit={onSubmit}
		busy={submitted}
	>

		<InputReadOnlyUI name='billName' label='Bill name'
			required={true} value={selectedBill.billName}
		/>
		<InputReadOnlyUI name='billAmount' label='Bill amount'
			required={true} value={selectedBill.billAmountF1}
		/>
		{
			otpRequested &&
			<InputTextSF type='text' name='otp' maxLength={6}
				label='OTP'
				value={otp} onChange={onOtpChange}
				error={otpError} setError={setOtpError}
			/>
		}
	</ModalFormUI>

export default PayModalUI
